import { FormInstance } from "../../models/site-content/form-instance.model";
import { IHomePageAction } from "./actions/i-home-page-action";

export enum HomePageActionsEnum {
    MANAGE_GRID_MODE = 'manage',
    VIEW_GRID_MODE = 'view',
    ACTION_DELETE = 'delete',
    //ACTION_COPY_MOVE = 'movecopy',
    ACTION_COPY = 'copy',
    ACTION_MOVE = 'move',
    ACTION_CREATE_FOLDER = 'createfolder',
    ACTION_CREATE_FORM = 'createform',
    ACTION_PUBLISH_FORM = 'publishform',
    ACTION_PUBLISH_FOLDER = 'publishfolder',
    ACTION_SUBSCRIBE_FOLDER = 'subscribefolder',
    ACTION_EXPORT_DATA = 'exportData',
    ACTION_BULK_WORKFLOW = 'bulkWorkflow',
    ACTION_SUBSCRIBE_ALL = 'subscribeAll'
}

export enum MoveOrCopyEnum {
    MOVE = 'move',
    COPY = 'copy',
    CREATE_REF = 'ref'
}

export class HomePageActionDialogReturnObj {
    constructor(success: boolean = true, formInstance: FormInstance = null) {
        this.success = success;
        this.formInstance = formInstance;
    }

    public success: boolean;
    public formInstance: FormInstance;
    public folderToPublish: number;
    public subscribeFolderId: number;
}

export interface ActionNameToAction {
    [action: string]: IHomePageAction;
}

export class PerformActionParamObj {
    constructor(moveOrCopy: string, parentFolderId: number, parentFolderName: string, entityName: string) {
        this.moveOrCopy = moveOrCopy;
        this.folderId = parentFolderId;
        this.parentFolderName = parentFolderName;
        this.entityName = entityName;
    }

    public moveOrCopy: string;
    public folderId: number;
    public entityName: string;
    public parentFolderName: string;
}
